import React, { Component } from 'react';
import getConfig from "./UserBrowseConfig";
import { connect } from 'react-redux';
import { Search, X } from 'react-feather';
import { impersonateUser } from '../../actions/allActions';
import AdminStepUpPanel from './AdminStepUpPanel';
import AdminPasskeysList from './AdminPasskeysList';
import { clearStepUp, fetchPasskeyStatus, getStepUpToken, isStepUpRequired } from '../../util/adminStepUp';

const $ = require('jquery');
$.DataTable = require('datatables.net');
require("datatables.net-responsive");

class UserBrowse extends Component {
    // 'checking' -> 'needed' (passkey step-up panel) -> 'ok' (table)
    state = { stepUp: 'checking', passkeys: [] };

    componentDidMount() {
        this.checkStepUp();
    }

    componentDidUpdate(_prevProps, prevState) {
        if (prevState.stepUp !== 'ok' && this.state.stepUp === 'ok') this.initTable();
    }

    componentWillUnmount() {
        if (this.table) {
            $('#browse-table').off('click');
            this.table.destroy();
            this.table = null;
        }
    }

    checkStepUp = () => {
        fetchPasskeyStatus().then((status) => {
            // verified only when both the header token (table, impersonation) and the
            // cookie (Blazer, Sidekiq) hold a step-up; otherwise verify again, which sets both
            const valid = !status.step_up.enforced || (status.step_up.valid && status.step_up.tools_valid);
            if (!status.step_up.valid && getStepUpToken()) clearStepUp(); // expired or for another account
            this.setState({ stepUp: valid ? 'ok' : 'needed', passkeys: status.passkeys });
        }).catch(() => this.setState({ stepUp: 'needed' }));
    };

    // the server says the step-up lapsed (24 hours passed, or it was cleared)
    handleStepUpRequired = () => {
        clearStepUp();
        if (this.table) {
            $('#browse-table').off('click');
            this.table.destroy();
            this.table = null;
        }
        this.setState({ stepUp: 'checking' }, this.checkStepUp);
    };

    initTable() {
        $('#loader-wrapper').hide();
        $('#browse-table-wrapper').show();

        const config = getConfig({ onStepUpRequired: this.handleStepUpRequired });
        const table = $('#browse-table').DataTable(config);

        // One delegated handler, bound once (the per-draw rebinding fired the
        // impersonation once per binding). Matched on the button element in the
        // actions cell or Responsive's expanded child row.
        $('#browse-table').on('click', 'td.actions button.button--impersonate-user, td.child button.button--impersonate-user', (e) => {
            const userId = parseInt(e.currentTarget.getAttribute('data-user-id'));
            this.props.impersonateUser(userId)
                .then(() => this.props.history.push('/'))
                .catch((xhr) => { if (isStepUpRequired(xhr)) this.handleStepUpRequired(); });
        });

        table.on('draw', () => {
            $('#results-count').text(table.page.info().recordsDisplay);
        });

        $('#browse-table-search').on('keyup', function () {
            table.search(this.value).draw();
            $('#results-count').text(table.page.info().recordsDisplay);
        });

        $('th.sorting').on('click', function () {
            const filter = $(this).text();
            setTimeout(() => { table.draw(); }, 250);
            ahoy.track("Click Browse Filter", { filter });
        });
        this.table = table;
        setTimeout(() => { table.draw(); }, 250);
    }

    render() {
        return (
            <div className="layout layout--browse">
                <div className="layout--browse__container">
                    <div className="layout--browse__container__main">
                        <h1>Browse <span>Users</span></h1>
                        {this.state.stepUp === 'needed' && (
                            <AdminStepUpPanel hasPasskeys={this.state.passkeys.length > 0} onVerified={() => this.setState({ stepUp: 'checking' }, this.checkStepUp)} />
                        )}
                        {this.state.stepUp === 'ok' && <AdminPasskeysList passkeys={this.state.passkeys} />}
                        {this.state.stepUp === 'ok' && (<>
                        <div className='search-wrapper'>
                            <div className="browse-search">
                                <Search />
                                <input id="browse-table-search" className="browse-search__input" type="text" placeholder="Search for any user..." />
                            </div>
                        </div>
                        <div className='count-wrapper'><span id="results-count" className='count'>0</span><span className='label'>Users</span></div>
                        <div id="loader-wrapper" className="loader-wrapper">
                            <div className="lds-ellipsis">
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                            </div>
                        </div>
                        <div id="browse-table-wrapper" className="data-table-wrapper">
                            <table id="browse-table" className="responsive" style={{ width: '100%' }} />
                        </div>
                        </>)}
                    </div>
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => ({
    impersonateUser: (userId) => dispatch(impersonateUser(userId)),
});

export default connect(null, mapDispatchToProps)(UserBrowse);
